import { createStore } from "vuex";
import router from "@/router";

let localeUinfo = localStorage.getItem("userInfo") || null;

export default createStore({
  state: {
    userInfo: JSON.parse(localeUinfo) || {},
    isLoading: false,
  },
  getters: {},
  mutations: {
    setLoading(state, e) {
      state.isLoading = Boolean(e);
    },
    async setUserInfo(state, e) {
      let info = e;
      if (typeof e == "object") {
        state.userInfo = {
          ...state.userInfo,
          ...info,
        };
        localStorage.setItem("userInfo", JSON.stringify(info));
      }
    },
    signOut(state) {
      state.userInfo = {};
      localStorage.setItem("userInfo", JSON.stringify({}));
      router.push({
        name: "LoginView",
      });
    },
  },
  actions: {},
  modules: {},
});
